import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileLas.tsx
const IconFileLas = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#b08a06",
			fillRule: "evenodd",
			d: "M9 10a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1zm1.81.902v4.188h2.508v-.81h-1.596v-3.378zm5.861 4.188-.3-.996h-1.398l-.3.996h-.924l1.38-4.188h1.128l1.362 4.188zm-1.02-3.36h.03l.468 1.59h-.96zm2.968 3.246q.384.186.936.186.39 0 .696-.096.306-.102.51-.282.21-.18.318-.432t.108-.552q0-.546-.312-.84-.312-.3-.96-.402l-.414-.066q-.264-.042-.384-.138-.114-.096-.114-.312 0-.192.15-.3t.456-.108q.324 0 .534.114.216.108.366.282l.606-.612a1.7 1.7 0 0 0-.618-.438q-.36-.15-.834-.15-.372 0-.666.096a1.4 1.4 0 0 0-.492.258 1.2 1.2 0 0 0-.306.402 1.2 1.2 0 0 0-.108.516q0 .528.306.846.312.318.978.402l.414.054q.294.042.39.162a.43.43 0 0 1 .096.288.46.46 0 0 1-.162.366q-.162.138-.498.138a1.35 1.35 0 0 1-1.05-.48l-.6.606q.27.3.654.492",
			clipRule: "evenodd"
		})
	]
});
var IconFileLas_default = forwardRef(IconFileLas);
//#endregion
export { IconFileLas_default as default };
